var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSvg4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 742.418,
    height: 712.575,
    viewBox: "0 0 742.418 712.575",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29",
    "data-name": "Group 29",
    transform: "translate(-245 -109)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_339-349",
    "data-name": "Path 339",
    d: "M825.818,262.524h-3.9V155.547A61.915,61.915,0,0,0,760,93.632H533.353a61.915,61.915,0,0,0-61.916,61.916V742.43a61.915,61.915,0,0,0,61.915,61.915H760a61.915,61.915,0,0,0,61.915-61.915V338.672h3.9Z",
    transform: "translate(-147.004 15.369)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340-350",
    "data-name": "Path 340",
    d: "M808.736,150.925V746.1a46.959,46.959,0,0,1-46.942,46.952h-231.3A46.966,46.966,0,0,1,483.521,746.1V150.925a46.965,46.965,0,0,1,46.971-46.951H558.55a22.329,22.329,0,0,0,20.656,30.74H711.074a22.329,22.329,0,0,0,20.656-30.74h30.055a46.959,46.959,0,0,1,46.951,46.942Z",
    transform: "translate(-146.449 15.843)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    "data-name": "Group 26",
    transform: "translate(402.822 206.2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_45-351",
    "data-name": "Path 45",
    d: "M446.878,474.642a99.3,99.3,0,0,1-99.337-99.254V375.3c0-.208,0-.427.012-.635.3-54.4,44.863-98.7,99.325-98.7a99.337,99.337,0,1,1,.011,198.674h-.011Zm0-196.587a97.454,97.454,0,0,0-97.233,96.677c-.011.222-.011.4-.011.569a97.258,97.258,0,1,0,97.259-97.246Z",
    transform: "translate(-347.54 -275.967)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27",
    "data-name": "Group 27",
    transform: "translate(17.768 55.394)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 21.322,
    cy: 21.322,
    rx: 21.322,
    ry: 21.322,
    transform: "translate(16.803 0.451)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63-352",
    "data-name": "Path 63",
    d: "M476.175,412.51h-104.6a2.141,2.141,0,0,1-.391-.031l49.472-85.686a3.463,3.463,0,0,1,6.029,0l33.2,57.5,1.59,2.751Z",
    transform: "translate(-371.188 -325.034)",
    fill: "#800ba3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65-353",
    "data-name": "Path 65",
    d: "M533.713,412.268H443.245l17.53-25.464,1.261-1.835,22.844-33.184a4.622,4.622,0,0,1,6.866-.41,4.131,4.131,0,0,1,.329.41Z",
    transform: "translate(-370.49 -324.791)",
    fill: "#800ba3"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_39-354",
    "data-name": "Path 39",
    d: "M516.164,595.55H310.627a3.81,3.81,0,0,1-3.806-3.806V540.76a3.811,3.811,0,0,1,3.806-3.806H516.164a3.811,3.811,0,0,1,3.806,3.806v50.985a3.811,3.811,0,0,1-3.806,3.806ZM310.627,538.476a2.286,2.286,0,0,0-2.284,2.284v50.985a2.286,2.286,0,0,0,2.284,2.284H516.164a2.286,2.286,0,0,0,2.284-2.284V540.76a2.286,2.286,0,0,0-2.284-2.284Z",
    transform: "translate(88.717 -86.233)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 15.986,
    cy: 15.986,
    r: 15.986,
    transform: "translate(410.001 464.033)",
    fill: "#800ba3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40-355",
    "data-name": "Path 40",
    d: "M397.513,562.313a2.664,2.664,0,1,0,0,5.329H523.118a2.665,2.665,0,1,0,.087-5.328H397.513Z",
    transform: "translate(65.395 -92.952)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41-356",
    "data-name": "Path 41",
    d: "M397.513,584.061a2.664,2.664,0,1,0,0,5.329H523.118a2.665,2.665,0,1,0,.087-5.328H397.513Z",
    transform: "translate(65.395 -98.714)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42-357",
    "data-name": "Path 42",
    d: "M516.164,711.54H310.627a3.81,3.81,0,0,1-3.806-3.806V656.75a3.811,3.811,0,0,1,3.806-3.806H516.164a3.811,3.811,0,0,1,3.806,3.806v50.985A3.811,3.811,0,0,1,516.164,711.54ZM310.627,654.466a2.286,2.286,0,0,0-2.284,2.284v50.985a2.286,2.286,0,0,0,2.284,2.284H516.164a2.286,2.286,0,0,0,2.284-2.284V656.75a2.286,2.286,0,0,0-2.284-2.284Z",
    transform: "translate(88.717 -116.963)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 15.986,
    cy: 15.986,
    r: 15.986,
    transform: "translate(410.001 549.292)",
    fill: "#800ba3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43-358",
    "data-name": "Path 43",
    d: "M397.513,678.3a2.664,2.664,0,1,0,0,5.329H523.118a2.665,2.665,0,0,0,.087-5.328H397.513Z",
    transform: "translate(65.395 -123.682)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44-359",
    "data-name": "Path 44",
    d: "M397.513,700.051a2.664,2.664,0,1,0,0,5.329H523.118a2.665,2.665,0,0,0,.087-5.328H397.513Z",
    transform: "translate(65.395 -129.444)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39-2-360",
    "data-name": "Path 39",
    d: "M516.164,595.55H310.627a3.81,3.81,0,0,1-3.806-3.806V540.76a3.811,3.811,0,0,1,3.806-3.806H516.164a3.811,3.811,0,0,1,3.806,3.806v50.985a3.811,3.811,0,0,1-3.806,3.806ZM310.627,538.476a2.286,2.286,0,0,0-2.284,2.284v50.985a2.286,2.286,0,0,0,2.284,2.284H516.164a2.286,2.286,0,0,0,2.284-2.284V540.76a2.286,2.286,0,0,0-2.284-2.284Z",
    transform: "translate(88.717 84.286)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5-2",
    "data-name": "Ellipse 5",
    cx: 15.986,
    cy: 15.986,
    r: 15.986,
    transform: "translate(410.001 634.552)",
    fill: "#800ba3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40-2-361",
    "data-name": "Path 40",
    d: "M397.513,562.313a2.664,2.664,0,1,0,0,5.329H523.118a2.665,2.665,0,1,0,.087-5.328H397.513Z",
    transform: "translate(65.395 77.567)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41-2-362",
    "data-name": "Path 41",
    d: "M397.513,584.061a2.664,2.664,0,1,0,0,5.329H523.118a2.665,2.665,0,1,0,.087-5.328H397.513Z",
    transform: "translate(65.395 71.805)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28",
    "data-name": "Group 28",
    transform: "translate(733.282 333.482)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_409-363",
    "data-name": "Path 409",
    d: "M616.354,733.283H603.9l-5.924-48.033h18.379Z",
    transform: "translate(-579.376 -258.561)",
    fill: "#feb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_410-364",
    "data-name": "Path 410",
    d: "M781.847,821.454H741.693v-.508a15.63,15.63,0,0,1,15.628-15.629h24.527Z",
    transform: "translate(-741.693 -334.661)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_411-365",
    "data-name": "Path 411",
    d: "M764.825,725.426,752.7,728.28l-16.778-45.4,17.89-4.213Z",
    transform: "translate(-573.145 -258.858)",
    fill: "#feb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_412-366",
    "data-name": "Path 412",
    d: "M932.408,812.63l-39.085,9.2-.116-.494a15.63,15.63,0,0,1,11.63-18.8h0l23.872-5.621Z",
    transform: "translate(-734.869 -335.04)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_413-367",
    "data-name": "Path 413",
    d: "M775.572,619.007c.024-2.5.765-61.577,16.958-83.913l.239-.33L849.2,542.55l-1.262,12.4c2.482,2.414,22.006,22.816,27.644,71.128l59.9,160.867-27.845,2.531L825.205,613.867l-43.62,190.884h-27.6Z",
    transform: "translate(-741.138 -346.881)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_414-368",
    "data-name": "Path 414",
    d: "M784.539,541.411l5.516-28.96c-1.08-1.39-5.865-8.065-4.8-15.89.695-5.105,3.742-9.582,9.059-13.309l14.3-33.362.193-.113c.963-.567,23.728-13.731,36.139-1.311.31.24,30.867,24.5,18.6,57.218l-15.148,45.45Z",
    transform: "translate(-739.758 -351.018)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_415-369",
    "data-name": "Path 415",
    d: "M766.675,576.428a10.241,10.241,0,0,0,8.649-13.106l29.527-21.273-17.676-6.723-25.329,21.232a10.3,10.3,0,0,0,4.829,19.871Z",
    transform: "translate(-741.086 -346.855)",
    fill: "#feb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_416-370",
    "data-name": "Path 416",
    d: "M771.369,546.127l45.078-35.516-13.4-45.787a16.451,16.451,0,0,1,1.661-13.02,15.216,15.216,0,0,1,9.977-7.2c7.717-1.633,14.722,2.688,20.817,12.845l.047.092c1.008,2.465,24.492,60.516,6.561,72.931-17.541,12.143-58.215,29.821-58.624,30l-.477.206Z",
    transform: "translate(-740.353 -350.968)",
    fill: "#ccc"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_66",
    "data-name": "Ellipse 66",
    cx: 27.308,
    cy: 27.308,
    r: 27.308,
    transform: "translate(63.619 30.758)",
    fill: "#feb8b8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 24.158,
    cy: 24.158,
    r: 24.158,
    transform: "translate(109.58)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_417-371",
    "data-name": "Path 417",
    d: "M891.2,398.231A24.16,24.16,0,0,1,853.9,385.546a24.16,24.16,0,1,0,47.126-9.907A24.151,24.151,0,0,1,891.2,398.231Z",
    transform: "translate(-736.626 -354.068)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_418-372",
    "data-name": "Path 418",
    d: "M798.37,398.1c4.217-7.55,5.831-10.7,11.269-15.3,4.809-4.061,10.724-5.253,15.495-1.406a28.737,28.737,0,1,1-17.044,23C803.942,403.815,802.517,398.686,798.37,398.1Z",
    transform: "translate(-739.134 -353.913)",
    fill: "#2f2e41"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_419-373",
    "data-name": "Path 419",
    d: "M1395.965,822.09H657.424c-1.071,0-1.938-.468-1.938-1.045s.868-1.045,1.938-1.045h738.541c1.07,0,1.938.468,1.938,1.045S1397.036,822.09,1395.965,822.09Z",
    transform: "translate(-410.486 -0.515)",
    fill: "#e6e6e6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg4);
export default __webpack_public_path__ + "static/media/svg4.a89871845d5606e01ac27cd9817d8dc8.svg";
export { ForwardRef as ReactComponent };